module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8003.59a3f980.png";